export var TaskType;
(function (TaskType) {
    TaskType[TaskType["Event"] = 0] = "Event";
    TaskType[TaskType["People_Activity"] = 1] = "People_Activity";
    TaskType[TaskType["Others"] = 2] = "Others";
})(TaskType || (TaskType = {}));
